import { render, staticRenderFns } from "./CellSizeCard.vue?vue&type=template&id=00990165"
import script from "./CellSizeCard.vue?vue&type=script&lang=ts"
export * from "./CellSizeCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports